import { render, staticRenderFns } from "./CoursewareListContainer.vue?vue&type=template&id=e4b11508&"
import script from "./CoursewareListContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4b11508')) {
      api.createRecord('e4b11508', component.options)
    } else {
      api.reload('e4b11508', component.options)
    }
    module.hot.accept("./CoursewareListContainer.vue?vue&type=template&id=e4b11508&", function () {
      api.rerender('e4b11508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareListContainer.vue"
export default component.exports